{
  "id": "campaign-091",
  "name": "Old Gate",
  "seed": "campaign:91",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    ".....__.....",
    "...i.__.i...",
    "....x__.....",
    ".....__.....",
    ".i.i.__.i.i.",
    ".....__.....",
    "____________",
    ".....__.....",
    "...qL__L....",
    ".....__~....",
    ".i.i.__.i.i.",
    ".....__~....",
    "...%.__.q...",
    ".....__.....",
    "....X.......",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 1,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 1
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 11,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 9
    },
    {
      "kind": "repair",
      "x": 3,
      "y": 0
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "falls": [
    {
      "x": 4,
      "y": 15,
      "dir": "E",
      "at": 14,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 91,
  "biome": "cemetery",
  "par": {
    "reel": 5970,
    "push": 5187,
    "selfPropelled": 4920,
    "tractor": 4670,
    "zeroTurn": 3411,
    "fairway": 2948
  },
  "routeTries": {
    "par": {
      "reel": 7,
      "push": 23,
      "selfPropelled": 7,
      "tractor": 17,
      "zeroTurn": 3,
      "fairway": 12
    }
  }
}
